export default __webpack_public_path__ + "locales/nl/DataReassignmentDialog.json?hash=016c33e1dc1ff31bdbd5521d2f1b45ca";